import { LoadableFactory } from '®shared/data';

import {
  ListsForResourceActionTypes,
  ListsForResourceActions,
} from './lists-for-resource.actions';
import { ListsForResourceState } from './lists-for-resource.state';

export function listsForResourceReducer(
  state: ListsForResourceState,
  action: ListsForResourceActions,
): ListsForResourceState {
  switch (action.type) {
    case ListsForResourceActionTypes.FETCH_LISTS_FOR_RESOURCE: {
      return {
        ...state,
        listsForResource: LoadableFactory.loading(),
      };
    }

    case ListsForResourceActionTypes.FETCH_LISTS_FOR_RESOURCE_SUCCESS: {
      return {
        ...state,
        listsForResource: LoadableFactory.loaded(
          action.payload.listsForResourceData,
        ),
      };
    }

    case ListsForResourceActionTypes.FETCH_LISTS_FOR_RESOURCE_FAILED: {
      return {
        ...state,
        ...LoadableFactory.errored(action.payload),
      };
    }

    default: {
      return state;
    }
  }
}
